import React, { useEffect, useState } from "react";
import {
  Date,
  HighlightedOverlay,
  ScheduleDateTime,
  ScheduleItem,
  ScheduleItemWrapper,
  ScheduleLabel,
  ScheduleListWrapper,
  ScheduleTime,
  ScheduleWrapper,
  Title,
} from "./Calendar.style";
import { formatSchedulerDate, formatTime } from "hhn-commons";
import { PatientHeaderDescription } from "../message/messageHeader/patientGroupHeader/PatientHeaderDescription";
import { getAvatarSize, GROUP_AVATAR_SIZE } from "../utils/AvatarUtils";
import { GROUP_TYPE, IScheduledVisits } from "@home-health-notify/domain";
import DisplayAvatarImage from "../common/DisplayAvatarImage";
import { ListItemAvatar } from "@mui/material";
import {
  ChatListItemTitle,
  ChatListItemWrapper,
  ListItemWrapper,
} from "../chats/ChatList.style";

interface IScheduleProps {
  events: IScheduledVisits[];
  clickedEventId?: string;
}

const Schedule = ({ events, clickedEventId }: IScheduleProps) => {
  const [highlightClickedEvent, setHighlightClickedEvent] =
    useState<boolean>(false);

  useEffect(() => {
    if (clickedEventId) {
      setHighlightClickedEvent(true);
      setTimeout(() => {
        setHighlightClickedEvent(false);
      }, 1500);
    }
  }, [clickedEventId]);

  return (
    <ScheduleWrapper>
      <ScheduleLabel>Schedule</ScheduleLabel>
      <ScheduleListWrapper>
        {(events || []).map(item => {
          const showEventTime =
            item.schedulerTime !== undefined &&
            item.schedulerEndTime !== undefined;
          const isPatientGroup = item.groupType === GROUP_TYPE.PATIENT;
          return (
            <ScheduleItemWrapper
              key={item.id}
              id={`scheduled-visit-event-${item.id}`}
            >
              {highlightClickedEvent && clickedEventId === item.id && (
                <HighlightedOverlay />
              )}
              <ScheduleItem>
                <ScheduleDateTime>
                  <Date>{formatSchedulerDate(item.schedulerDate)}</Date>
                  {showEventTime && (
                    <ScheduleTime>
                      {`${formatTime(item.schedulerTime ?? 0)} - ${formatTime(
                        item.schedulerEndTime ?? 0,
                      )}`}
                    </ScheduleTime>
                  )}
                </ScheduleDateTime>
                <Title>{item.title}</Title>
                {isPatientGroup ? (
                  <PatientHeaderDescription
                    name={item.name}
                    patientStatus={item.patientStatus}
                    servicesToPatient={[]} // Passing empty array for services to patients because we don't want to show the services here
                    fontSizeTitle={16}
                    avatarSize={GROUP_AVATAR_SIZE.SMALL}
                  />
                ) : (
                  <ListItemWrapper>
                    <ListItemAvatar>
                      <DisplayAvatarImage
                        src={item.image}
                        alt={item.name}
                        avatarSize={getAvatarSize(
                          GROUP_TYPE.PRIVATE,
                          GROUP_AVATAR_SIZE.SMALL,
                        )}
                      />
                    </ListItemAvatar>
                    <ChatListItemWrapper>
                      <ChatListItemTitle
                        data-testid="chat-name"
                        noWrap
                        sx={{ fontWeight: 500 }}
                      >
                        {item.name}
                      </ChatListItemTitle>
                    </ChatListItemWrapper>
                  </ListItemWrapper>
                )}
              </ScheduleItem>
            </ScheduleItemWrapper>
          );
        })}
      </ScheduleListWrapper>
    </ScheduleWrapper>
  );
};

export default Schedule;
